import { Alert, Card, Drawer, Divider, Image, Upload, Button, Form, Input, UploadProps, UploadFile } from 'antd';
import React, { useEffect, useState } from 'react';
import AssignmentService from '../../../services/AssignmentService';
import { openNotification } from '../../../utils';
import { PlusOutlined } from '@ant-design/icons';
import '../../../components/Assignments/assignment-detail.css';

interface ReminderAssignmentDetailProps {
  assignmentId: number | null;
  open: boolean;
  onClose: () => void;
}

const { TextArea } = Input;

const ReminderAssignmentDetail: React.FC<ReminderAssignmentDetailProps> = ({ assignmentId, open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState<any>(null);
  const [filesUrl, setFilesUrl] = useState<string | null>(null);
  const [filesUrl2, setFilesUrl2] = useState<string | null>(null);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [form] = Form.useForm();
  const isExpired = Boolean(item?.isExpired) && !item?.isDone;

  useEffect(() => {
    if (open && assignmentId) {
      setLoading(true);
      AssignmentService.get(assignmentId)
        .then((res: any) => {
          setItem(res?.data);
        })
        .catch((e: Error) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [open, assignmentId]);

  useEffect(() => {
    const fetchFiles = async () => {
      if (item?.image) {
        try {
          const response = await AssignmentService.getFile(item?.image);
          const blobType = response.headers['content-type'];
          const fileBlob = new Blob([response.data], { type: blobType });
          setFilesUrl(URL.createObjectURL(fileBlob));
        } catch (error) {
          console.error('File fetching failed:', error);
        }
      } else {
        setFilesUrl(null);
      }

      if (item?.responseImage) {
        try {
          const response = await AssignmentService.getFile(item?.responseImage);
          const blobType = response.headers['content-type'];
          const fileBlob = new Blob([response.data], { type: blobType });
          setFilesUrl2(URL.createObjectURL(fileBlob));
        } catch (error) {
          console.error('File fetching failed:', error);
        }
      } else {
        setFilesUrl2(null);
      }
    };

    if (open && item) {
      fetchFiles();
    }
  }, [open, item]);

  const handleRespondSubmit = () => {
    if (isExpired) {
      openNotification('warning', 'Süresi Doldu', 'Teslim süresi dolan ödeve cevap gönderemezsiniz.');
      return;
    }

    form
      .validateFields()
      .then(values => {
        form.resetFields();
        let postObj: any = {
          responseContent: values.responseContent,
          isDone: true,
        };

        AssignmentService.update(item?.id, postObj, fileList[0])
          .then(() => {
            openNotification('success', 'Başarılı', 'Ödeve Cevap Verildi.');
            onClose();
          }).catch((e: Error) => {
            console.log(e)
          });
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const props: UploadProps = {
    onPreview: async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj as any);
      }
    },
    onRemove: () => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      if (fileList.length >= 1) {
        openNotification('warning', 'Uyarı', 'Sadece bir adet dosya yükleyebilirsiniz')
        return Upload.LIST_IGNORE;
      }
      setFileList([file]);
      return false;
    },
    fileList,
    defaultFileList: fileList,
    accept: '.jpg',
    multiple: false,
  };

  const getBase64 = (file: any): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Yükle</div>
    </button>
  );

  return (
    <Drawer title="Ödev Detay" placement="right" onClose={onClose} open={open} style={{ padding: 0, margin: 0, border: 'none' }}>
      <Card loading={loading} className='assignment-detail-card' style={{ border: 'none' }} bodyStyle={{ padding: 0, margin: 0, border: 'none' }}>
        <h4>Ders</h4>
        <p>{item?.lessonName}</p>
        <Divider />
        <h4>Ödev İçerik</h4>
        <p>{item?.content}</p>
        {item?.image ? (
          <>
            <Divider />
            <h4>Soru Görsel</h4>
            {filesUrl && (
              <Image src={filesUrl} fallback="error.png" />
            )}
          </>
        ) : null}
        {item?.responseContent ? (
          <>
            <Divider />
            <h4>Cevap Detay</h4>
            <p>{item.responseContent}</p>
          </>
        ) : isExpired ? (
          <>
            <Divider />
            <Alert
              message="Süresi Doldu"
              description="Teslim süresi dolduğu için bu ödeve cevap veya dosya ekleyemezsiniz."
              showIcon
              type="warning"
            />
          </>
        ) : (
          <>
            <Divider />
            <Form form={form} layout="vertical">
              <Form.Item name="responseContent" label="Cevap" rules={[{ required: true, message: 'Cevap giriniz' }]}>
                <TextArea />
              </Form.Item>
              <Form.Item name="responseImage" label="Görsel Cevap" >
                <Upload {...props} listType="picture-card">
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
              </Form.Item>
            </Form>
            <Button onClick={handleRespondSubmit} disabled={item?.isDone} style={{ marginLeft: 10 }}>Cevapla</Button>
          </>
        )}
        {item?.responseImage ? (
          <>
            <Divider />
            <h4>Cevap Görsel</h4>
            {filesUrl2 && (
              <Image src={filesUrl2} fallback="error.png" />
            )}
          </>
        ) : null}
        <Divider />
      </Card>
    </Drawer>
  );
};

export default ReminderAssignmentDetail;
